export default "/images/rosplast.jpg?0606d0b70a5c29cd875f15c6511e0c3f";